<template>
  <tag
    :is="tag"
    v-html="message"
  />
</template>

<script>
import { i18n } from '@shared/i18n';

export default {
  name: 'app-i18n',
  props: {
    code: String,
    args: {
      type: Array,
      default: () => ([])
    },
    tag: {
      type: String,
      default: 'span',
      validator(tag) {
        return [
          'span', 'p', 'strong', 'i', 'div',
          'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
        ].indexOf(tag.toLowerCase()) > -1;
      }
    }
  },
  computed: {
    message() {
      return i18n(this.code, ...this.args);
    },
  },
};
</script>
